import styled from "styled-components";
import Header from "../../components/common/Header";
import { useParams } from "react-router-dom";
import Footer from "../../components/common/Footer";
import useProduct from "../../hooks/product/useProduct";
import Modal from "../../components/common/Modal";
import ProductItem from "../../components/product/ProductItem";

function Product(){
    const { id } = useParams();
    const {product, isOpenModal, modal,
        selectedClass, selectedOptionList, onProductItemChangeHandler,
        onAddToCartClickHandler
    } = useProduct(id);

    const renderClassList = () => {
        if(product && product.class_list.length){
            const list = product.class_list;
            list.sort((a, b) => {
                return a.amount - b.amount;
            })
            return list.map((item, index) => {
                return <ProductItem key={item.id}
                        id={item.id}
                        name={"class"}
                        label={item.name}
                        amount={item.amount}
                        onChange={onProductItemChangeHandler}
                        checked={selectedClass === item.id}
                    />
            })
        }
        return null;
    }

    const renderOptonList = () => {
        if(product && product.option_list.length){
            const list =product.option_list;
            list.sort((a, b) => {
                return a.amount - b.amount;
            })
            return list.map((item, index) => {
                return <ProductItem key={item.id}
                        id={item.id}
                        name={"option"}
                        label={item.name}
                        amount={item.amount}
                        onChange={onProductItemChangeHandler}
                        checked={selectedOptionList.includes(item.id)}
                    />
            })
        }
        return null;
    }
    return(
        <Conatiner>
            <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} closeButtonName={modal.buttonName} onClose={modal.onConfirmClickHandler}/>
            <Header />
            <div className="inner">
                <Content>
                    <ProductHeader >
                        <ThumbnailImg src={product.thumbnail_img} alt="thumbnail_img"/>
                        <Title>{product.title}</Title>
                    </ProductHeader>
                    <ProductMenu>
                        <Label>CLASS</Label>
                        <ProductItemList>
                            {renderClassList()}
                        </ProductItemList>
                        <HorizontalSprator />
                        <Label>OPTION</Label>
                        <ProductItemList>
                            {renderOptonList()}
                        </ProductItemList>
                        <Description>*서비스 제공기간은 12개월 입니다*</Description>
                        <Button onClick={onAddToCartClickHandler}>장바구니에 추가</Button>
                    </ProductMenu>
                    <ProductDetail>
                        <DetailImg src={product.detail_img} alt="detail_img"/>
                    </ProductDetail>
                </Content>
            </div>
            <Footer />
        </Conatiner>
    )
}

const Conatiner = styled.div`
    width: 100vw;
    min-height: 100vh;
`

const Content = styled.div`
    padding-top: 160px;
    padding-bottom: 120px;
    display: flex;
    flex-direction: column;
    gap: 80px;
`

const ProductHeader = styled.div`
    display: flex;
    gap: 20px;
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: center;
    }
`

const ThumbnailImg = styled.img`
    width: 300px;
`

const Title = styled.div`
    color: #222;
    font-size: 24px;
    font-weight: 700;
    width: fit-content;
`

const ProductMenu = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
    gap: 20px;
    border-radius: 20px;
    background-color: #EBEBEB;
`

const ProductItemList = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
`

const HorizontalSprator = styled.div`
    background-color: #58AC65;
    height: 1px;
`

const Label = styled.div`
    color: #222;
    font-size: 20px;
    font-weight: 550;
`

const ProductDetail = styled.div`
    background-color: #EBEBEB;
    border-radius: 20px;
    overflow: hidden;
`


const DetailImg = styled.img`
    width: 100%;
`

const Description = styled.div`
    font-size: 14px;
`

const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    width: 100%;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
`

export default Product;